import { render, staticRenderFns } from "./LoginCard.vue?vue&type=template&id=316efda9&scoped=true"
import script from "./LoginCard.vue?vue&type=script&lang=ts"
export * from "./LoginCard.vue?vue&type=script&lang=ts"
import style0 from "./LoginCard.vue?vue&type=style&index=0&id=316efda9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "316efda9",
  null
  
)

export default component.exports